import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

import { ProjectService } from "../../shared/services/project.service";
import { ISelectableProject } from "./models/ISelectableProject";
import { BehaviorSubject, Observable, combineLatest } from "rxjs";
import { FormControl } from "@angular/forms";
import { finalize, map, startWith, tap, shareReplay } from "rxjs/operators";
import { IProject } from "../../projects/shared/models/IProject";

@Component({
  selector: "app-choose-project",
  templateUrl: "./choose-project.component.html",
  styleUrls: ["./choose-project.component.scss"],
})
export class ChooseProjectComponent implements OnInit {
  @Input() selectedProjects: IProject[];

  private loadingSubject = new BehaviorSubject<boolean>(false);
  private availableProjects: ISelectableProject[] = [];

  loading$ = this.loadingSubject.asObservable();
  keywordFilter = new FormControl("");
  projects$: Observable<ISelectableProject[]>;

  constructor(
    private activeModal: NgbActiveModal,
    private projectService: ProjectService
  ) {}

  ngOnInit() {
    this.loadingSubject.next(true);

    const allProjects$ = this.projectService.getProjects().pipe(
      finalize(() => this.loadingSubject.next(false)),
      map((projects) => {
        return projects
          .map((project) => {
            const selectedProject = this.selectedProjects.find(
              (p) => project.id === p.id
            );
            const isSelected = !!selectedProject;
            const canBeToggled = !(
              isSelected &&
              selectedProject.timeEntries &&
              selectedProject.timeEntries.length > 0
            );
            const selectableProject: ISelectableProject = Object.assign(
              { selected: isSelected, canBeToggled },
              project
            );
            return selectableProject;
          });
          //.sort(this.sortBySelectedThenName.bind(this));
      }),
      shareReplay(1)
    );
    allProjects$.subscribe((projects) => {
      this.availableProjects = projects;
    });
    const keywordFilter$ = this.keywordFilter.valueChanges.pipe(startWith(""));

    this.projects$ = combineLatest([allProjects$, keywordFilter$]).pipe(
      map(([projects, keyword]) => {
        return projects.filter((project) => this.search(project, keyword));
      })
    );
  }
  toggle(project: ISelectableProject) {
    if (project.canBeToggled) {
      project.selected = !project.selected;
    }
  }
  selectAll(selecting: boolean) {
    this.projects$.forEach((e) => {
      e.map(p => p.selected = selecting);
    })
  }
  close() {
    this.activeModal.close(this.availableProjects.filter((p) => p.selected));
  }
  dismiss() {
    this.activeModal.dismiss();
  }
  private search(project: ISelectableProject, text: string) {
    const keyword = text.toLowerCase();
    // TODO this wont be quite as cool as the vs code file search.. update that
    return project.name.toLowerCase().includes(keyword);
  }
  private sortBySelectedThenName(a: ISelectableProject, b: ISelectableProject) {
    // sort selected first
    if (a.selected && !b.selected) {
      return -1;
    } else if (!a.selected && b.selected) {
      return 1;
    }
    // then name
    return this.projectService.sortByName(a, b);
  }
}
